import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './YouTubeModalButton.css';

const YouTubeModalButton = ({ videoId }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="youtube-button-wrapper">
        <button className="youtube-btn" onClick={handleShow}>
          <i className="fab fa-youtube"></i>
        </button>
      </div>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              title="YouTube video"
              allowFullScreen
              allow="autoplay; encrypted-media"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default YouTubeModalButton;
